import { ShieldCheck } from "lucide-react";

export function SlotGuardPanel({ guard, onChange }) {
  const set = (k, v) => onChange({ ...guard, [k]: v });
  const Row = ({ k, label, min, max, step }) => (
    <label className="flex items-center justify-between text-[11px] text-[#848e9c]">{label}<input type="number" min={min} max={max} step={step} value={guard[k] ?? ""} onChange={(e) => set(k, Number(e.target.value))} className="input mono !w-20 h-7 py-0 text-right shrink-0" data-testid={`slot-guard-${k}-input`} /></label>
  );
  const Toggle = ({ k, label }) => (
    <label className="flex items-center gap-2 text-[11px] text-[#eaecef]"><input type="checkbox" checked={guard[k] ?? true} onChange={(e) => set(k, e.target.checked)} className="accent-[#fcd535]" data-testid={`slot-guard-${k}-toggle`} />{label}</label>
  );
  return (
    <div className="panel p-3 space-y-2" data-testid="slot-guard-panel">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5"><ShieldCheck size={13} className={guard.enabled ?? true ? "text-[#fcd535]" : "text-[#5e6673]"} /><div className="panel-title">Slot guard (bot-managed)</div></div>
        <Toggle k="enabled" label="Enabled" />
      </div>
      <div className="text-[10px] text-[#5e6673]">Deterministic slot hygiene on every tick — the same actions you can take from a slot by hand. It never widens a stop or adds size.</div>
      <div className="space-y-1.5 border-t border-[#1e2329] pt-2">
        <Toggle k="auto_breakeven" label="Move stop to breakeven (entry + fees) once a trade has earned…" />
        <Row k="breakeven_trigger_r" label="…this many R (multiples of initial risk)" min={0.3} max={3} step={0.1} />
      </div>
      <div className="space-y-1.5 border-t border-[#1e2329] pt-2">
        <Toggle k="trailing" label="After breakeven, trail the stop behind price (ratchets only in your favour)" />
        <Row k="trail_r" label="…trail distance in R" min={0.3} max={3} step={0.1} />
      </div>
      <div className="space-y-1.5 border-t border-[#1e2329] pt-2">
        <Toggle k="auto_close_danger" label="Close early when a losing position is aging AND about to be stopped" />
        <Row k="danger_budget" label="…stop budget left ≤ (fraction)" min={0.05} max={0.6} step={0.05} />
        <Row k="danger_hold_pct" label="…and hold time ≥ (fraction of max hold)" min={0.3} max={1} step={0.05} />
      </div>
      <div className="text-[10px] text-[#5e6673]">Red slots = ≤{Math.round((guard.danger_budget ?? 0.25) * 100)}% stop budget. Swing positions use 24h as their max hold for the aging rule; scalps use their own max hold.</div>
    </div>
  );
}
